<template>
    <el-dialog title="經常性費用項目" :visible="visible" width="30%" @close="handleClose">
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="項目名稱">
                <el-input v-model="form.iteM_NAM"></el-input>
            </el-form-item>
            <el-form-item label="金額限制">
                <el-input v-model.number="form.amT_S"></el-input>
                <el-input v-model.number="form.amT_E"></el-input>
            </el-form-item>
            <el-form-item label="請款流程">
                <draggable v-model="form.auditFlowItems" draggable=".item">
                    <div v-for="(element, index) in form.auditFlowItems" :key="index" :class="{ item: element.typ === 0 }">
                        <el-button v-if="element.menU_UNT === 'ADD'" icon="el-icon-plus" circle @click="addFlowMember(index)">新增</el-button>
                        <p v-else-if="element.typ === 1">
                            <span>{{ index + 1 }}.</span><span>{{ element.menU_UNT }}</span>
                        </p>
                        <div v-else>
                            <span>=</span><span>{{ index + 1 }}.</span>
                            <el-select v-model="element.value" placeholder="请选择" @change="value => handleMemberSelect(value, index)">
                                <el-option-group v-for="group in memberSelections" :key="group.label" :label="group.label">
                                    <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                </el-option-group>
                            </el-select>
                            <span @click="deleteItem(index)">X</span>
                        </div>
                    </div>
                </draggable>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button v-show="inputObject" type="danger" @click="deleteData">刪除</el-button>
            <el-button type="primary" @click="handleSubmit">送出</el-button>
        </span>
    </el-dialog>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        inputObject: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            form: {
                sno: null,
                iteM_NAM: '',
                amT_S: null,
                amT_E: null,
                auditFlowItems: [],
            },
            memberSelections: [],
        };
    },
    created() {
        this.$api({
            url: '/CurrentExpenditureSettingPage/GetAuditStaffOptions',
            method: 'GET',
        })
            // 取得成功
            .then((resp) => {
                // 更新資料
                // this.memberList = resp.data.options;
                this.memberSelections = [
                    {
                        label: '職位',
                        options: [
                            {
                                value: '1/主管',
                                label: '主管',
                            },
                        ],
                    },
                    {
                        label: '員工',
                        options: resp.data.options
                            .filter((o) => o.grP_NO !== 'OT1')
                            .filter((o) => o.grP_NO !== 'OT2')
                            .filter((o) => o.grP_NO !== 'OT3')
                            .filter((o) => o.grP_NO !== 'OT4')
                            .map((x) => ({
                                value: `2/${x.sno}/${x.nam}`,
                                label: x.nam,
                            })),
                    },
                ];
            });

        if (this.inputObject) {
            this.form = JSON.parse(JSON.stringify(this.inputObject));

            this.form.auditFlowItems = this.form.auditFlowItems.map((x) => ({
                ...x,
                value: x.rolE_TYP === 1 ? '1/主管' : `2/${x.elsE_STF_SNO}/${x.menU_UNT}`,
            }));
        } else {
            this.$api({
                url: '/CurrentExpenditureSettingPage/GetDefaultAuditFlow',
                method: 'GET',
            })
                // 取得成功
                .then((resp) => {
                    // 更新資料
                    this.form.auditFlowItems = resp.data.auditFlowItems;
                });
        }
    },
    methods: {
        handleClose(refresh = false) {
            this.$emit('close', refresh);
        },
        handleSubmit() {
            this.form.auditFlowItems = this.form.auditFlowItems.filter((x) => !!x.rolE_TYP);
            this.$api({
                url: 'CurrentExpenditureSettingPage/UpsertSetting',
                method: 'POST',
                data: this.form,
            })
                // 取得成功
                .then(() => {
                    this.handleClose(true);
                });
        },
        addFlowMember(index) {
            this.form.auditFlowItems.splice(index, 0, {
                elsE_STF_SNO: null,
                menU_UNT: '',
                rolE_TYP: 0,
                sno: null,
                sot: 0,
                typ: 0,
            });
        },
        deleteData() {
            this.$api({
                url: `CurrentExpenditureSettingPage/DeleteSettings?SnoList=${this.form.sno}`,
                method: 'DELETE',
            })
                // 取得成功
                .then(() => {
                    this.$router.push({
                        name: 'current-expenditure',
                    });
                });
        },
        handleMemberSelect(value, index) {
            const datas = value.split('/');
            if (datas[0] === '1') {
                this.form.auditFlowItems[index].rolE_TYP = parseInt(datas[0]);
                this.form.auditFlowItems[index].menU_UNT = datas[1];
            } else if (datas[0] === '2') {
                this.form.auditFlowItems[index].rolE_TYP = parseInt(datas[0]);
                this.form.auditFlowItems[index].elsE_STF_SNO = datas[1];
                this.form.auditFlowItems[index].menU_UNT = datas[2];
            }
        },
        deleteItem(index) {
            this.form.auditFlowItems.splice(index, 1);
        },
    },
};
</script>
